export const environment = {
    production    : true,
    VERSION       : '1.0.1',
    DEFAULT_LANG  : 'en',
    BASE_URL      : 'https://staging.ledgersyncappv2.com',
    API_URL       : 'https://staging.ledgersyncappv2.com/api',
    PUBLIC_API_URL: 'https://staging.ledgersyncappv2.com/api/public',
    V3_API_URL    : 'https://sandbox-api.ledgersyncappv2.com',
    WS_URL        : 'wss://staging.ledgersyncappv2.com/ws',
    ZOHO_URL      : 'https://subscriptions.zoho.com/portal/ledgersynctest',
    // AI connector sign-in (card #1310). Host of the connector WorkOS AuthKit that /connect-ai may send the
    // browser to; blank until that WorkOS environment exists, which keeps the Allow button from navigating.
    CONNECTOR_AUTHKIT_HOST: 'zippy-horse-22-staging.authkit.app',
    PORTAL_BASE_URL: 'https://portal.ledgersyncappv2.com',
    CONNECTOR_DEPLOYMENT: 'sandbox',
};
